module.exports = __webpack_public_path__ + "static/media/spange-brown.4f49ce41.jpg";